import { useDetailApi } from "../../../swr/useApi";
import { loyaltyService } from "../../api_client";
import type { LoyaltyConfigDto } from "../../../api";
import type { AxiosResponse } from "axios";

/**
 * Buyer-readable loyalty config (earn rate + redemption value + validity).
 * Uses the public `/loyalty/config` endpoint so non-admin users can preview
 * the discount value of redeeming points at checkout.
 *
 * The `getConfig` method on `loyaltyService` is added by `npm run generate:api`
 * after the BE controller exposes it; the cast below disappears post-regen.
 */
export function useBuyerLoyaltyConfig() {
    return useDetailApi<LoyaltyConfigDto>({
        key: "buyer-loyalty-config",
        serviceMethod: async () => {
            const svc = loyaltyService as unknown as {
                getConfig: () => Promise<AxiosResponse<LoyaltyConfigDto>>;
            };
            return await svc.getConfig();
        },
    });
}
